import styled from 'styled-components'

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`

export const CardWrapper = styled.div`
  margin-top: 10px;
`
